import { render, staticRenderFns } from "./ProductRecipe.vue?vue&type=template&id=3f8d2f44"
import script from "./ProductRecipe.vue?vue&type=script&lang=js"
export * from "./ProductRecipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports